module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/Gorilla-f1acd06c4dc24312e5859d407dc9571a.png";